module.exports = __webpack_public_path__ + "img/logo.d646c2cb.png";